import {
  Merchant, Branch, User, Device, Product, PriceList, PriceListItem,
  Stock, StockMovement, Sale, SaleItem, Payment, Customer,
  MurabahaCase, Contract, Order, Connector, ConnectorLog,
  Module, ModuleConnection, ModuleSyncStat
} from '@/types';

const uid = (prefix: string, n: number) => `${prefix}-${String(n).padStart(3, '0')}`;
const now = '2026-02-27T10:00:00Z';
const ago = (days: number) => {
  const d = new Date('2026-02-27');
  d.setDate(d.getDate() - days);
  return d.toISOString();
};

export const merchant: Merchant = {
  id: 'merchant-001', name: 'Hisob Demo Do\'kon', legal_name: 'Hisob Demo LLC',
  inn: '123456789', address: 'Toshkent, Amir Temur ko\'chasi 1', phone: '+998901234567',
  platform_status: 'active', trust_level: 'green', admin_comment: '', created_at: ago(90),
};

export const branches: Branch[] = [
  { id: 'branch-001', merchant_id: 'merchant-001', name: 'Markaziy filial', address: 'Toshkent, Amir Temur 1', phone: '+998901234567', is_active: true, created_at: ago(90) },
  { id: 'branch-002', merchant_id: 'merchant-001', name: 'Chilonzor filial', address: 'Toshkent, Chilonzor 5', phone: '+998901234568', is_active: true, created_at: ago(60) },
];

export const users: User[] = [
  { id: 'user-001', merchant_id: 'merchant-001', branch_id: null, full_name: 'Aziz Karimov', email: 'aziz@hisob.uz', phone: '+998901111111', role: 'owner', is_active: true, created_at: ago(90) },
  { id: 'user-002', merchant_id: 'merchant-001', branch_id: 'branch-001', full_name: 'Dilshod Toshmatov', email: 'dilshod@hisob.uz', phone: '+998902222222', role: 'manager', is_active: true, created_at: ago(60) },
  { id: 'user-003', merchant_id: 'merchant-001', branch_id: 'branch-001', full_name: 'Nodira Umarova', email: 'nodira@hisob.uz', phone: '+998903333333', role: 'cashier', is_active: true, created_at: ago(30) },
];

export const devices: Device[] = [
  { id: 'device-001', branch_id: 'branch-001', merchant_id: 'merchant-001', name: 'Kassa 1', device_type: 'tablet', serial_number: 'TAB-2026-001', is_active: true, created_at: ago(30) },
];

const categories = ['Elektronika', 'Maishiy texnika', 'Kiyim', 'Oziq-ovqat', 'Mebel'];

// Each product gets a unit matching its real-world nature
const productUnits = [
  // Elektronika (0-4)
  'dona', 'dona', 'dona', 'dona', 'dona',
  // Maishiy texnika (5-9)
  'dona', 'dona', 'dona', 'dona', 'dona',
  // Kiyim (10-14)
  'dona', 'dona', 'dona', 'dona', 'dona',
  // Oziq-ovqat (15-19)
  'kg', 'kg', 'kg', 'pachka', 'litr',
  // Mebel (20-24)
  'dona', 'dona', 'dona', 'dona', 'dona',
  // Elektronika (25-29)
  'dona', 'dona', 'dona', 'dona', 'dona',
];

export const products: Product[] = Array.from({ length: 30 }, (_, i) => ({
  id: uid('prod', i + 1),
  merchant_id: 'merchant-001',
  sku: `SKU-${String(i + 1).padStart(4, '0')}`,
  barcode: `4780000${String(i + 1).padStart(6, '0')}`,
  mhik: `${String(10000000000000000 + i * 1000000000)}`.slice(0, 17),
  name: [
    'Samsung Galaxy A54', 'iPhone 15', 'Xiaomi Redmi Note 13', 'AirPods Pro', 'MacBook Air M2',
    'Konditsioner Artel', 'Kir yuvish mashinasi LG', 'Muzlatgich Samsung', 'Mikroto\'lqinli pech', 'Changyutgich Dyson',
    'Erkaklar ko\'ylagi', 'Ayollar ko\'ylagi', 'Bolalar kurtka', 'Sport shim', 'Klassik kostyum',
    'Guruch 1kg', 'Un 2kg', 'Shakar 1kg', 'Choy Tess 100p', 'Sut Lakto 1L',
    'Ofis stol', 'Ofis stul', 'Shkaf 3-eshikli', 'Divan', 'Karavot 160x200',
    'Planshet Samsung Tab', 'Smart soat Huawei', 'Quloqchin Sony', 'Printer HP', 'Monitor Dell 27"',
  ][i],
  unit: productUnits[i] || 'dona',
  category: categories[Math.floor(i / 6)],
  is_murabaha_eligible: i < 15,
  is_active: true,
  created_at: ago(60),
}));

export const priceLists: PriceList[] = [
  { id: 'pl-001', merchant_id: 'merchant-001', name: 'Asosiy narxlar', is_default: true, created_at: ago(60) },
  { id: 'pl-002', merchant_id: 'merchant-001', name: 'Chegirmali narxlar', is_default: false, created_at: ago(30) },
];

export const priceList: PriceList = priceLists[0];

const prices = [
  3200000, 14500000, 2800000, 1500000, 18000000,
  4500000, 5200000, 7800000, 1200000, 3500000,
  250000, 180000, 350000, 200000, 1200000,
  18000, 22000, 14000, 35000, 12000,
  2500000, 800000, 3500000, 8000000, 5000000,
  4800000, 1800000, 900000, 2200000, 3800000,
];

export const priceListItems: PriceListItem[] = products.map((p, i) => ({
  id: uid('pli', i + 1), price_list_id: 'pl-001', product_id: p.id, price: prices[i],
}));

export const stocks: Stock[] = products.map((p, i) => ({
  id: uid('stock', i + 1), branch_id: 'branch-001', product_id: p.id,
  quantity: 10 + Math.floor(Math.random() * 90), updated_at: now,
}));

export const stockMovements: StockMovement[] = Array.from({ length: 20 }, (_, i) => ({
  id: uid('sm', i + 1), branch_id: 'branch-001', product_id: products[i % 30].id,
  movement_type: (['IN', 'OUT', 'IN', 'ADJUST'] as const)[i % 4],
  quantity: 5 + Math.floor(Math.random() * 20),
  reference: `REF-${i + 1}`, created_by: 'user-002', created_at: ago(i),
}));

const payMethods: Array<'cash' | 'card' | 'hisob_wallet'> = ['cash', 'card', 'hisob_wallet'];

export const sales: Sale[] = Array.from({ length: 50 }, (_, i) => ({
  id: uid('sale', i + 1), merchant_id: 'merchant-001', branch_id: i < 35 ? 'branch-001' : 'branch-002',
  cashier_id: 'user-003', total_amount: 100000 + Math.floor(Math.random() * 15000000),
  payment_method: payMethods[i % 3], is_murabaha: i < 10,
  murabaha_case_id: i < 10 ? uid('mc', i + 1) : null,
  status: 'completed', created_at: ago(i % 30),
}));

export const saleItems: SaleItem[] = sales.flatMap((s, si) => {
  const count = 1 + (si % 3);
  return Array.from({ length: count }, (_, j) => {
    const prod = products[(si * 3 + j) % 30];
    const price = prices[(si * 3 + j) % 30];
    const qty = 1 + (j % 3);
    return {
      id: uid('si', si * 3 + j + 1), sale_id: s.id, product_id: prod.id,
      product_name: prod.name, quantity: qty, unit_price: price, total: price * qty,
    };
  });
});

export const payments: Payment[] = sales.map((s, i) => ({
  id: uid('pay', i + 1), sale_id: s.id, method: s.payment_method, amount: s.total_amount, created_at: s.created_at,
}));

export const customers: Customer[] = Array.from({ length: 12 }, (_, i) => ({
  id: uid('cust', i + 1), merchant_id: 'merchant-001',
  full_name: ['Bobur Aliyev', 'Kamola Rashidova', 'Sardor Nazarov', 'Gulnora Karimova', 'Jamshid Tursunov',
    'Malika Abdullayeva', 'Otabek Mirzayev', 'Zulfiya Hasanova', 'Rustam Rahimov', 'Dilorom Yusupova',
    'Sherzod Mamatov', 'Nilufar Ergasheva'][i],
  passport: `A${String(1000000 + i)}`, pinfl: `3${String(1000000000000 + i)}`,
  phone: `+99890${String(4000000 + i)}`, created_at: ago(30 + i),
}));

const mStatuses: Array<'Draft' | 'PendingCustomerConfirmation' | 'Approved' | 'Rejected' | 'Completed' | 'Cancelled'> =
  ['Draft', 'PendingCustomerConfirmation', 'Approved', 'Completed', 'Completed', 'Rejected', 'Completed', 'PendingCustomerConfirmation', 'Cancelled', 'Completed'];

const mPayStatuses: Array<'none' | 'in_progress' | 'cancelled' | 'paid'> =
  ['none', 'none', 'in_progress', 'paid', 'paid', 'none', 'paid', 'none', 'cancelled', 'paid'];

export const murabahaCases: MurabahaCase[] = Array.from({ length: 10 }, (_, i) => ({
  id: uid('mc', i + 1), merchant_id: 'merchant-001', branch_id: 'branch-001',
  customer_id: uid('cust', i + 1), cashier_id: 'user-003',
  sale_id: uid('sale', i + 1), total_amount: sales[i].total_amount,
  limit_amount: sales[i].total_amount + 5000000,
  status: mStatuses[i], payment_status: mPayStatuses[i],
  contract_id: uid('contract', i + 1), order_id: uid('order', i + 1),
  created_at: ago(25 - i), updated_at: ago(20 - i),
}));

export const contracts: Contract[] = murabahaCases.map((mc, i) => ({
  id: uid('contract', i + 1), murabaha_case_id: mc.id,
  contract_number: `CTR-2026-${String(i + 1).padStart(4, '0')}`,
  total_amount: mc.total_amount * 1.15, monthly_payment: Math.round(mc.total_amount * 1.15 / 12),
  term_months: 12, status: mc.status === 'Completed' ? 'signed' : 'draft' as any,
  created_at: mc.created_at,
}));

export const orders: Order[] = murabahaCases.map((mc, i) => ({
  id: uid('order', i + 1), murabaha_case_id: mc.id,
  order_number: `ORD-2026-${String(i + 1).padStart(4, '0')}`,
  items: JSON.stringify(saleItems.filter(si => si.sale_id === mc.sale_id).map(si => ({ name: si.product_name, qty: si.quantity }))),
  total_amount: mc.total_amount, status: mc.status === 'Completed' ? 'confirmed' : 'draft' as any,
  created_at: mc.created_at,
}));

export const connectors: Connector[] = [
  { id: 'conn-01', code: 'CUSTOMER_LOOKUP', name: 'Mijoz qidirish', mode: 'MOCK', is_enabled: true, base_url: 'https://mock.hisob.uz/customer-lookup', api_key_masked: '****1234', created_at: ago(90) },
  { id: 'conn-02', code: 'CUSTOMER_CREATE_KYC', name: 'Mijoz yaratish (KYC)', mode: 'MOCK', is_enabled: true, base_url: 'https://mock.hisob.uz/kyc', api_key_masked: '****5678', created_at: ago(90) },
  { id: 'conn-03', code: 'LIMIT_CHECK', name: 'Limit tekshirish', mode: 'MOCK', is_enabled: true, base_url: 'https://mock.hisob.uz/limit', api_key_masked: '****9012', created_at: ago(90) },
  { id: 'conn-04', code: 'CONTRACT_ENGINE', name: 'Shartnoma tizimi', mode: 'MOCK', is_enabled: true, base_url: 'https://mock.hisob.uz/contract', api_key_masked: '****3456', created_at: ago(90) },
  { id: 'conn-06', code: 'NOTIFICATION', name: 'Bildirishnoma', mode: 'MOCK', is_enabled: true, base_url: 'https://mock.hisob.uz/notify', api_key_masked: '****2345', created_at: ago(90) },
  { id: 'conn-07', code: 'PAYMENTS', name: 'To\'lov tizimi', mode: 'MOCK', is_enabled: true, base_url: 'https://mock.hisob.uz/payments', api_key_masked: '****6789', created_at: ago(90) },
  { id: 'conn-08', code: 'LEDGER_SETTLEMENT', name: 'Hisob-kitob', mode: 'MOCK', is_enabled: true, base_url: 'https://mock.hisob.uz/ledger', api_key_masked: '****0123', created_at: ago(90) },
  { id: 'conn-09', code: 'SHARIAH_GUARD', name: 'Shariah nazorat', mode: 'MOCK', is_enabled: true, base_url: 'https://mock.hisob.uz/shariah', api_key_masked: '****4567', created_at: ago(90) },
];

export const connectorLogs: ConnectorLog[] = Array.from({ length: 20 }, (_, i) => ({
  id: uid('cl', i + 1), connector_code: connectors[i % connectors.length].code,
  direction: i % 2 === 0 ? 'request' : 'response', method: 'POST',
  url: connectors[i % connectors.length].base_url, status_code: i % 2 === 0 ? null : 200,
  body: JSON.stringify({ mock: true, data: `Sample ${i + 1}` }),
  created_at: ago(i),
}));

export const modules: Module[] = [
  { id: 'mod-01', code: 'hisob-supply', name: 'Hisob Supply', group: 'commerce', status: 'Ulanmagan', view_url: '/modules/supply', created_at: ago(90) },
  { id: 'mod-02', code: 'hisob-logistics', name: 'Hisob Logistics', group: 'commerce', status: 'Ulanmagan', view_url: '/modules/logistics', created_at: ago(90) },
  { id: 'mod-03', code: 'hisob-pos', name: 'Hisob POS', group: 'commerce', status: 'Ulangan', view_url: '/', created_at: ago(90) },
  { id: 'mod-04', code: 'hisob-hrm-ewa', name: 'Hisob HRM+EWA', group: 'business_ops', status: 'Ulanmagan', view_url: '/modules/hrm-ewa', created_at: ago(90) },
  { id: 'mod-05', code: 'hisob-servis', name: 'Hisob Servis (Accounting)', group: 'business_ops', status: 'Ulanmagan', view_url: '/modules/accounting', created_at: ago(90) },
  { id: 'mod-06', code: 'hisob-crm', name: 'Hisob CRM', group: 'business_ops', status: 'Ulanmagan', view_url: '/modules/crm', created_at: ago(90) },
  { id: 'mod-07', code: 'soliqhujjat', name: 'SoliqHujjat', group: 'business_ops', status: 'Ulanmagan', view_url: '/modules/soliqhujjat', created_at: ago(90) },
  { id: 'mod-08', code: 'e-hujjat', name: 'e-Hujjat', group: 'business_ops', status: 'Ulanmagan', view_url: '/modules/e-hujjat', created_at: ago(90) },
];

export const moduleConnections: ModuleConnection[] = [
  { id: 'mconn-01', merchant_id: 'merchant-001', module_code: 'hisob-pos', status: 'Ulangan', connected_at: ago(90), last_sync_at: now, config_json: '{}' },
];

export const moduleSyncStats: ModuleSyncStat[] = [
  { id: 'mss-01', merchant_id: 'merchant-001', module_code: 'hisob-pos', object_type: 'sales', object_count: 50, updated_at: now },
  { id: 'mss-02', merchant_id: 'merchant-001', module_code: 'hisob-pos', object_type: 'products', object_count: 30, updated_at: now },
];

// Helper to format UZS
export const formatUZS = (amount: number): string => {
  return new Intl.NumberFormat('uz-UZ').format(amount) + ' so\'m';
};

export const getProductPrice = (productId: string): number => {
  return priceListItems.find(p => p.product_id === productId)?.price ?? 0;
};
